import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'app/components/ui/alert-dialog';
import { useToast } from 'app/components/ui/use-toast';
import { useProductsSlice } from 'app/pages/Product/slice';
import { useEffect } from 'react';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}

export function AlertProductCategoriesDelete({
  isOpen,
  onOpenChange,
  data,
}: Props) {
  const { useDeleteProductsCategoriesMutation } = useProductsSlice();
  const { toast } = useToast();

  const [
    deleteCategories,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteProductsCategoriesMutation();
  const handleDelete = () => {
    deleteCategories(data.category_id);
  };

  useEffect(() => {
    if (deleteError) {
      toast({
        title: 'Error',
        description: deleteError?.message || 'An error occurred',
        variant: 'destructive',
      });
    }
  }, [deleteError, toast]);

  useEffect(() => {
    if (deletedData) {
      toast({
        title: 'Success',
        description: deletedData?.message || 'Category deleted successfully',
        variant: 'default',
      });
      onOpenChange(false);
    }
  }, [deletedData, onOpenChange, toast]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
